import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CognitoService } from 'src/app/auth/services/cognito.service';

@Injectable({
  providedIn: 'root'
})
export class RetailGuard implements CanActivate, CanActivateChild {
  constructor(private cognitoService: CognitoService, private router: Router) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return from(this.cognitoService.getUser()).pipe(
      map((userInfo: any) => {
        if (!userInfo || !userInfo.attributes || !userInfo.attributes.email) {
          return this.router.createUrlTree(['/auth/login']);
        }

        const userGroup = userInfo.attributes['custom:user-group'];

        if (userGroup === 'aguacate_retail_cashier' || userGroup === 'aguacate_retail_client') {
          return true;
        }

        if (userGroup === 'aguacate_client' || userGroup === 'aguacate_operator') {
          return this.router.createUrlTree(['/wallet']);
        }

        return this.router.createUrlTree(['/auth/login']);
      }),
      catchError(() => {
        return of(this.router.createUrlTree(['/auth/login']));
      })
    );
  }
}
